//对账

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class ReconciliationState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    SIGNING = new Meta(2, "签署中");
    REJECTED = new Meta(3, "已驳回");
    FINISHED = new Meta(4, "已完成");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}

export const RECONCILIATION_STATE = new ReconciliationState();

class QueryType extends UltMeta {
    ONE = new Meta(1, "作为供货单位");
    TWO = new Meta(2, "作为对账单位");
}

export const QUERY_TYPE = new QueryType();

/**
 * 类型
 */
class Type extends UltMeta {
    ONE = new Meta(1, "直采-下游采购商", "01");
    TWO = new Meta(2, "联合采购-联合采购商", "02");
    THREE = new Meta(3, "联合采购-下游采购商", "03");
}

export const TYPE = new Type();

/**
 * 开票类型
 */
class InvoiceState extends UltMeta {
    NOT_INVOICED = new Meta(1, "未开票");
    FINISHED = new Meta(2, "已开票");
}

export const INVOICE_STATE = new InvoiceState();
